<template>
    <vue-scroll>
        <points />
    </vue-scroll>
</template>

<script>
import Points from "@/views/pages/order/dashboard/Points";

export default {
    components: {
        Points,
    },
};
</script>

<style scoped></style>
